/** Static Figma Admin MailGun fixtures (`40005433:20000`). */

export const MAILGUN_ROWS = [
  {
    id: "1",
    domain: "amokearth.com",
    privateKey: "935aa68e8bee37ecf733acd44b3ada60",
    fromAddress: "noreply@amokearth.com",
    ccEmails: ["record@amokearth.com"],
    status: "active",
    createdAt: "May 20, 2026, 11:33 AM",
    updatedAt: "May 25, 2026, 12:02 AM",
  },
  {
    id: "2",
    domain: "staging.amokearth.com",
    privateKey: "a4f2c91d0e8b7364521ac9de003f71b8",
    fromAddress: "noreply@staging.amokearth.com",
    ccEmails: ["devops@amokearth.com", "alerts@amokearth.com"],
    status: "active",
    createdAt: "July 15, 2026, 5:48 PM",
    updatedAt: "July 20, 2026, 8:30 AM",
  },
  {
    id: "3",
    domain: "mg.amokearth.com",
    privateKey: "7c3b9e1f4a286d9053e7c1b4a286d905",
    fromAddress: "hello@mg.amokearth.com",
    ccEmails: ["support@amokearth.com"],
    status: "inactive",
    createdAt: "May 20, 2026, 11:33 AM",
    updatedAt: "May 25, 2026, 12:02 AM",
  },
  {
    id: "4",
    domain: "notify.amokearth.com",
    privateKey: "f8e2d1c0b9a876543210fedcba987654",
    fromAddress: "notify@amokearth.com",
    ccEmails: ["ops@amokearth.com"],
    status: "active",
    createdAt: "June 1, 2026, 9:17 AM",
    updatedAt: "June 6, 2026, 3:45 PM",
  },
]

export const getMailGunConfig = configId =>
  MAILGUN_ROWS.find(row => String(row.id) === String(configId)) || null
